import { Grid, LinearProgress} from "@mui/material"
import PropTypes from 'prop-types'

ProgressBar.propTypes = {
    loading: PropTypes.bool,
}

export default function ProgressBar({ loading }) {
    return (
        <Grid container justifyContent="center" alignItems="center"
            sx={{ height: '65vh' }}
        >
            <Grid item xs={8} style={{ textAlign: 'center' }}>
                { loading && <LinearProgress /> }
            </Grid>
        </Grid>
    )
}
